"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.044 16h.03a.554.554 0 0 0 .196-.036c3.232-1.23 5.346-3.41 6.284-6.48.745-2.442.566-4.919.288-6.533l-1.091.285c.456 2.637.809 9.027-5.693 11.619-3.4-1.355-5.357-3.884-5.812-7.517-.3-2.398.18-4.546.327-5.125 1.158-.861 4.074-1.09 5.512-1.09 1.484.011 4.264.319 5.405 1.093l.117.079 1.103-.502-.289-.255C12.75.057 8.482.005 8.114 0h-.029C6.878.036 3.223.146 1.716 1.48a.55.55 0 0 0-.164.257c-.032.106-3.082 10.659 6.294 14.227a.56.56 0 0 0 .198.036Zm.58-4.188h-1.1V10.7h1.1v1.11Zm-.01-7.624H7.511l.121 5.336h.86l.12-5.336Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.799 23.878c.053.02.11.03.167.03h.045a.47.47 0 0 0 .166-.03c4.848-1.844 8.018-5.11 9.422-9.707 1.116-3.657.853-7.383.436-9.795l-.923.242c.721 4.173 1.267 14.282-9.124 18.33-5.453-2.124-8.585-6.132-9.31-11.914-.496-3.946.355-7.437.544-8.145 2.212-1.794 8.318-1.836 8.754-1.836h.055c2.148.017 6.603.447 8.518 1.746l.96-.437C19.128.252 12.757.077 12.046.097 9.877.16 4.638.377 2.498 2.274a.473.473 0 0 0-.138.216c-.048.16-4.615 16.042 9.439 21.388Zm1.028-6.202H11.19v-1.654h1.637v1.654Zm-.016-11.347h-1.637l.179 7.94h1.277l.18-7.94Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.732 31.837a.628.628 0 0 0 .222.041h.06a.624.624 0 0 0 .222-.04c6.464-2.46 10.69-6.815 12.562-12.944 1.488-4.876 1.138-9.844.582-13.06l-1.231.323c.962 5.564 1.69 19.042-12.165 24.44C8.713 27.764 4.537 22.42 3.57 14.711c-.66-5.262.474-9.917.726-10.86 2.949-2.392 11.09-2.449 11.672-2.449h.074c2.863.023 8.803.596 11.356 2.33l1.28-.584C25.505.336 17.009.102 16.063.13 13.17.213 6.184.503 3.33 3.032a.63.63 0 0 0-.184.288c-.064.213-6.153 21.39 12.585 28.517Zm1.372-8.269H14.92v-2.205h2.183v2.205Zm-.023-15.13h-2.183l.24 10.588h1.702l.241-10.588Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M23.588 47.938c.107.04.221.062.336.062h.09a.945.945 0 0 0 .335-.062c9.772-3.718 16.162-10.3 18.99-19.567 2.25-7.371 1.721-14.88.88-19.744l-1.86.49c1.453 8.41 2.554 28.786-18.39 36.945C12.977 41.782 6.662 33.703 5.2 22.048c-.997-7.954.717-14.992 1.1-16.418 4.458-3.614 16.765-3.7 17.645-3.7a1.716 1.716 0 0 1 .06 0h.053c4.328.034 13.307.9 17.166 3.52l1.936-.88C38.361.316 25.517-.04 24.087.003 19.713.13 9.153.568 4.84 4.39a.941.941 0 0 0-.28.438c-.095.321-9.3 32.334 19.027 43.11Zm2.08-12.501h-3.301v-3.334h3.3v3.334Zm-.034-22.873h-3.3l.362 16.007h2.575l.363-16.007Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M31.45 63.918c.142.054.294.082.447.082h.12c.153 0 .305-.028.447-.082 13.03-4.958 21.55-13.735 25.321-26.09 3-9.828 2.294-19.841 1.173-26.325l-2.48.652c1.937 11.214 3.405 38.383-24.52 49.26C17.3 55.71 8.881 44.939 6.933 29.399c-1.33-10.606.954-19.99 1.463-21.892 5.945-4.82 22.353-4.934 23.527-4.934h.15c5.771.046 17.743 1.2 22.89 4.694l2.58-1.174C51.146.42 34.021-.052 32.114.004c-5.83.17-19.91.754-25.66 5.85a1.255 1.255 0 0 0-.373.583c-.128.429-12.402 43.112 25.368 57.48Zm2.772-16.67h-4.4v-4.444h4.4v4.445Zm-.044-30.496h-4.4l.483 21.343h3.433l.483-21.343Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconSafetyInfo = function IconSafetyInfo(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Safety Info' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "SafetyInfo"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconSafetyInfo.sizes = [16, 24, 32, 48, 64];
IconSafetyInfo.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconSafetyInfo;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/coverage-options/SafetyInfo.js
// module id = 2039
// module chunks = 0